import type { CityConfig } from "../city-template/types";

export const gaithersburgConfig: CityConfig = {
  city: "Gaithersburg",
  state: "Maryland",
  stateAbbr: "MD",
  slug: "gaithersburg",
  route: "/gaithersburg",
  title: "Emergency Passport Gaithersburg, MD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Gaithersburg, Maryland — as fast as 24 hours. Fast passport renewal and new passport applications for Gaithersburg, Germantown, North Potomac, and Clarksburg residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Gaithersburg, MD",
  heroSubtitle: "Gaithersburg travelers — from I-270 tech corridor professionals to Kentlands families to multicultural communities — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Montgomery County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Modern%20suburban%20downtown%20Gaithersburg%20Maryland%20with%20the%20Kentlands%20town%20center%2C%20mixed-use%20buildings%20with%20brick%20and%20modern%20architecture%2C%20tree-lined%20streets%2C%20warm%20spring%20afternoon%20lighting%2C%20professional%20photography%2C%20clean%20architectural%20details%2C%20no%20visible%20text%20or%20people%2C%20green%20foliage%20and%20family-friendly%20suburban%20atmosphere%2C%20vibrant%20community%20feel%20with%20outdoor%20seating%20and%20pedestrian%20walkways&width=1800&height=700&seq=gaithersburg-hero-001&orientation=landscape",
  heroImageAlt: "Modern suburban downtown Gaithersburg Maryland with Kentlands town center and mixed-use architecture",
  geoPosition: "39.1434;-77.2014",
  geoPlacename: "Gaithersburg, Maryland",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, 1st Floor, Washington, DC 20006",
    distance: "Approximately 30–40 minutes from Gaithersburg via I-270 S and I-495 S",
  },
  nearbyCitiesZips: [
    { name: "Gaithersburg", zips: "20877, 20878, 20879, 20882, 20883, 20884, 20885, 20898, 20899" },
    { name: "Germantown", zips: "20874, 20875, 20876" },
    { name: "North Potomac", zips: "20878, 20854" },
    { name: "Clarksburg", zips: "20871" },
    { name: "Darnestown", zips: "20874, 20878" },
    { name: "Poolesville", zips: "20837" },
    { name: "Montgomery Village", zips: "20877, 20886" },
    { name: "Derwood", zips: "20855" },
    { name: "Rockville", zips: "20847, 20848, 20849, 20850, 20851, 20852, 20853, 20857" },
    { name: "Bethesda", zips: "20814, 20815, 20816, 20817, 20824, 20827, 20889, 20892, 20894" },
    { name: "Potomac", zips: "20854, 20859" },
    { name: "Silver Spring", zips: "20901, 20902, 20903, 20904, 20905, 20906, 20910, 20911" },
    { name: "Frederick", zips: "21701, 21702, 21703, 21704, 21705, 21709" },
    { name: "Damascus", zips: "20872" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for Gaithersburg and I-270 tech corridor departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "Tech Corridor Hub", desc: "Serving biotech, IT, and government contractor professionals" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to downtown DC" },
  ],
  internalLinks: [
    { name: "Expedited passport in Rockville, MD", route: "/rockville" },
    { name: "Emergency passport help in Bethesda, MD", route: "/bethesda" },
    { name: "Urgent passport services in Germantown, MD", route: "/germantown" },
    { name: "Maryland passport services overview", route: "/maryland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Gaithersburg, Maryland remotely via secure registered courier. We do not have a walk-in office in Gaithersburg — our registered couriers hand-deliver your documents to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Gaithersburg travelers without the drive to downtown DC.",
  fpcOfficeAddress: "401 E Pratt St, Baltimore, Maryland 21202",
  fpcOfficeDistance: "Serving Gaithersburg, Germantown, North Potomac, Clarksburg, and greater Montgomery County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout the Gaithersburg area and greater Montgomery County. From the bustling Kentlands town center and the I-270 tech corridor to the diverse residential neighborhoods of Montgomery Village and the quiet rural outskirts of Poolesville and Damascus, from the biotech hubs near Shady Grove to the family-friendly communities of North Potomac — we serve all of Gaithersburg's diverse communities.",
  nearbyCitiesIntro: "We serve Gaithersburg and nearby communities including Germantown, North Potomac, Clarksburg, Darnestown, Poolesville, Montgomery Village, Derwood, Rockville, Bethesda, and Potomac. We also serve cross-border travelers in Frederick, Damascus, and Silver Spring who prefer our expedited service.",
  howItWorksIntro: "Most Gaithersburg travelers complete everything online and ship documents overnight. No need to drive 30–40 minutes to downtown DC or navigate the I-270/I-495 interchange during rush hour.",
  mistakesIntro: "Gaithersburg is a major tech corridor hub with a diverse, internationally mobile population. Here are the most common passport mistakes we see from Gaithersburg travelers.",
  testimonialsIntro: "Gaithersburg travelers — from tech professionals to biotech researchers to multicultural families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Gaithersburg, MD? Here are the most common ones we hear from Montgomery County travelers.",
  statePageRoute: "/states/maryland",
  statePageName: "Maryland",
  dmvWebsite: "https://mva.maryland.gov",
  dmvLabel: "Maryland MVA — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Perfect for tech corridor travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 30–40 min to downtown DC", "Full day commitment — challenging for working professionals"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Gaithersburg travelers with immediate departure needs — as fast as 24 hours. Perfect for tech conferences, business trips, and last-minute international travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Tech and business travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Gaithersburg adults with a passport issued within the last 15 years.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to Gaithersburg address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Gaithersburg residents and families — including international students and visiting professionals.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Gaithersburg residents who lost their passport before travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Gaithersburg families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Gaithersburg residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Gaithersburg MD", description: "Urgent passport processing for Gaithersburg Maryland travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Gaithersburg MD", description: "Fast passport renewal for Gaithersburg Maryland residents with a previously-issued passport." },
    { name: "First-Time Passport Gaithersburg MD", description: "New passport application services for Gaithersburg Maryland residents applying for their first passport." },
    { name: "Child Passport Gaithersburg MD", description: "Minor passport services for Gaithersburg Maryland families with children under 16." },
  ],
  testimonials: [
    {
      name: "David C.",
      location: "Kentlands, Gaithersburg",
      rating: 5,
      text: "Tech conference in Berlin in 6 days. Fast Passport Center reviewed every document, caught a photo issue, and delivered my passport in 42 hours. Essential for professionals with tight travel schedules.",
      service: "Emergency Passport",
    },
    {
      name: "Maria R.",
      location: "Germantown, MD",
      rating: 5,
      text: "Family trip to Colombia with 10 days notice. Five passports processed in under a week. The agent coordinated everything — we just shipped the docs from the UPS Store on Shady Grove Rd.",
      service: "Family Passport Bundle",
    },
    {
      name: "Kevin L.",
      location: "North Potomac, MD",
      rating: 5,
      text: "Business trip to Singapore with 8 days notice. Fast Passport Center had my renewed passport ready in 2 days. No need to drive to DC — everything shipped overnight.",
      service: "Passport Renewal",
    },
    {
      name: "Priya S.",
      location: "Gaithersburg, MD",
      rating: 5,
      text: "Last-minute family emergency required travel to India. They understood the cultural urgency and had my passport in my hands within 36 hours. Respectful service for multicultural families.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "gaithersburg-1",
      name: "Gaithersburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15833 Gaither Dr",
      city: "Gaithersburg",
      state: "MD",
      zip: "20877",
      phone: "(301) 990-6640",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Gaithersburg area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Gaithersburg acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "gaithersburg-2",
      name: "Germantown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "12210 Middlebrook Rd",
      city: "Germantown",
      state: "MD",
      zip: "20874",
      phone: "(301) 528-3536",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Germantown, approximately 4 miles north of Gaithersburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for Germantown and northern Montgomery County residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "gaithersburg-3",
      name: "Poolesville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "19944 Fisher Ave",
      city: "Poolesville",
      state: "MD",
      zip: "20837",
      phone: "(301) 349-5160",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Poolesville, approximately 12 miles west of Gaithersburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Poolesville and western Montgomery County residents. Good alternative when Gaithersburg appointments are full.",
      icon: "ri-mail-line",
    },
    {
      id: "gaithersburg-4",
      name: "Montgomery County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "50 Maryland Ave",
      city: "Rockville",
      state: "MD",
      zip: "20850",
      phone: "(240) 777-9460",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Rockville, approximately 6 miles east of Gaithersburg",
      website: "https://www.montgomerycountymd.gov/",
      websiteLabel: "Montgomery County",
      notes: "County-level facility with full passport acceptance. Extended hours compared to post office locations. Accessible via Metro Red Line to Rockville Station.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited DC slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 30–40 min drive to downtown DC", fpc: "No — ship from Gaithersburg" },
    { feature: "Tech Travel Support", agency: "No flexibility for conference schedules", fpc: "Yes — we handle business and tech cases" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Gaithersburg's busy tech professionals and commuters often discover passport needs just weeks before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local photo services in Gaithersburg sometimes produce photos that meet general ID requirements but not passport standards. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Gaithersburg and Montgomery County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking the Acceptance Facility Early",
      description: "Gaithersburg Post Office appointments fill up fast, especially during summer and holiday travel seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Government fees change periodically. Always verify current fees before submitting — incorrect payment means starting over.",
    },
    {
      icon: "ri-time-line",
      title: "Underestimating Routine Processing Time",
      description: "Gaithersburg residents often assume 4–6 weeks is enough. Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home in Gaithersburg, Germantown, or North Potomac." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx location near Kentlands or along Shady Grove Rd." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Gaithersburg address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Gaithersburg, MD?", a: "Fast Passport Center offers emergency passport processing in Gaithersburg, Maryland in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Washington DC Passport Agency (30–40 minutes from Gaithersburg) — without you needing to make the drive or fight I-270/I-495 traffic." },
    { q: "Does Gaithersburg have its own passport agency?", a: "No — neither Gaithersburg nor the state of Maryland has a regional passport agency. The closest facility is the Washington DC Passport Agency, approximately 30–40 minutes from Gaithersburg via I-270 S. Fast Passport Center's courier service means Gaithersburg residents never need to make that drive." },
    { q: "Can I get expedited passport services if I live in Germantown or North Potomac?", a: "Absolutely. Fast Passport Center serves all of the Gaithersburg area including Germantown, North Potomac, Clarksburg, Darnestown, Poolesville, and Montgomery Village. Our service works the same way — complete your application online, ship your documents, and we handle the rest." },
    { q: "How much does an expedited passport cost in Gaithersburg, MD?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your departure timeline." },
    { q: "What airports do Gaithersburg travelers use for international flights?", a: "Most Gaithersburg residents fly internationally through Dulles International Airport (IAD), approximately 25–35 minutes west via I-270 S and the Dulles Toll Road. Reagan National (DCA) is 30–40 minutes south via I-270 S. Baltimore-Washington International (BWI) is 40–50 minutes northeast via I-270 N and I-695 E. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "Can I get a passport for my whole family in Gaithersburg?", a: "Yes. Fast Passport Center handles multi-passport cases for families in Gaithersburg, Germantown, North Potomac, and surrounding areas. Whether you need child passports, renewals, or first-time applications for the whole family, we coordinate the process to ensure everyone is ready to travel." },
    { q: "Where is the closest passport acceptance facility to downtown Gaithersburg?", a: "The Gaithersburg Post Office at 15833 Gaither Dr is the primary downtown acceptance facility. The Germantown Post Office at 12210 Middlebrook Rd serves northern Montgomery County. The Montgomery County Clerk's Office at 50 Maryland Ave in Rockville serves the county with extended hours. All require appointments — book 1–2 weeks ahead." },
    { q: "How do I know if I need expedited or routine passport processing?", a: "If your travel is within 10 weeks, use expedited service. If your travel is within 2–3 weeks, use emergency expedited service. Routine processing takes 6–13 weeks and is only suitable for travel more than 3 months away. Gaithersburg residents should plan ahead, especially for tech conferences and international business travel." },
  ],
  photoLocations: [
    { name: "Walgreens — Gaithersburg", address: "18250 Contour Rd, Gaithersburg, MD 20877", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Gaithersburg", address: "300 E Diamond Ave, Gaithersburg, MD 20877", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "UPS Store — Gaithersburg", address: "12228 Darnestown Rd, Gaithersburg, MD 20878", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "FedEx Office — Gaithersburg", address: "9801 Washingtonian Blvd, Gaithersburg, MD 20878", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    { name: "MVA — Gaithersburg", address: "15 Metropolitan Grove Rd, Gaithersburg, MD 20878", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves Montgomery County and Gaithersburg area. REAL ID processing available.", featured: true },
    { name: "MVA — White Oak", address: "12335 Columbia Pike, Silver Spring, MD 20904", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves eastern Montgomery County and Silver Spring area. Full service including REAL ID.", featured: false },
  ],
  airports: [
    {
      code: "IAD",
      name: "Dulles International",
      distance: "25–35 minutes from Gaithersburg via I-270 S and Dulles Toll Road",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Primary international departure airport for Gaithersburg travelers. Direct flights to London, Frankfurt, Tokyo, and major European and Asian hubs. United Airlines hub.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Flight Info",
      featured: true,
    },
    {
      code: "DCA",
      name: "Reagan National (Washington DC)",
      distance: "30–40 minutes from Gaithersburg via I-270 S",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Closest airport for domestic connections. Limited international flights but excellent for connecting to major hubs.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Flight Info",
      featured: false,
    },
    {
      code: "BWI",
      name: "Baltimore-Washington International Thurgood Marshall",
      distance: "40–50 minutes from Gaithersburg via I-270 N and I-695 E",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Alternative for Southwest Airlines domestic connections and some Caribbean destinations.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Flight Info",
      featured: false,
    },
  ],
};